import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface RingBulletItemProps {
  children: ReactNode;
  className?: string;
}

// A list item with the Website 2.0 red ring bullet (used in menu detail
// lists, trigger cards, resource lists...). Render inside any <ul>.
const RingBulletItem = ({ children, className }: RingBulletItemProps) => (
  <li
    className={cn(
      "relative pl-5 before:absolute before:top-[7px] before:left-0 before:size-[9px] before:rounded-full before:border-[3px] before:border-primary",
      className,
    )}
  >
    {children}
  </li>
);

export default RingBulletItem;
